import React from "react";
import styles from "./styles.module.scss";
import { get } from "lodash";

const HospitalInfo = ({ bookingInfo, isTrungVuong }) => {
  const partner = get(bookingInfo, "partner");

  return (
    <div className={styles.title_hospital} style={isTrungVuong ? { marginBottom: "0px" } : undefined}>
      {!isTrungVuong && <p className={styles.sub_title}>PHIẾU KHÁM BỆNH</p>}
      <p
        className={styles.nameParner}
        style={isTrungVuong ? { marginTop: "16px" } : undefined}
      >
        {partner?.name}
      </p>
      <p className={styles.addressParner} style={isTrungVuong ? { marginBottom: "0px" } : undefined}>
        {partner?.address}
      </p>
    </div>
  );
};

export default HospitalInfo;
